import { useEffect, useRef, useState } from "react";
import { Trophy, Megaphone } from "@phosphor-icons/react";
import { api } from "../../lib/api";

const POLL_MS = 4000;
const ROTATE_MS = 6000;

export function MotivationBanner() {
  const [data, setData] = useState(null);
  const [msgIndex, setMsgIndex] = useState(0);
  const rotateRef = useRef(null);

  useEffect(() => {
    const fetchBanner = () => {
      api.get("/motivation-banner").then(({ data }) => setData(data)).catch(() => {});
    };
    fetchBanner();
    const poll = setInterval(fetchBanner, POLL_MS);
    return () => clearInterval(poll);
  }, []);

  useEffect(() => {
    if (!data?.messages?.length) return;
    rotateRef.current = setInterval(() => setMsgIndex((i) => (i + 1) % data.messages.length), ROTATE_MS);
    return () => clearInterval(rotateRef.current);
  }, [data?.messages?.length]);

  if (!data || (data.messages.length === 0 && data.leaderboard.length === 0)) return null;

  const message = data.messages.length ? data.messages[msgIndex % data.messages.length] : null;
  const topReps = data.leaderboard.slice(0, 3);

  return (
    <div data-testid="motivation-banner" className="flex items-center justify-between gap-6 bg-gradient-to-r from-igc-gold/15 via-igc-surface to-igc-surface border border-igc-gold/25 px-5 py-2.5 mb-6 text-sm overflow-hidden">
      <div className="flex items-center gap-2 min-w-0 flex-1">
        <Megaphone size={16} weight="fill" className="text-igc-goldText shrink-0" />
        {message && (
          <p key={msgIndex} data-testid="motivation-banner-message" className="text-igc-cream truncate animate-in fade-in duration-500">{message}</p>
        )}
      </div>
      {topReps.length > 0 && (
        <div className="flex items-center gap-4 shrink-0" data-testid="motivation-banner-leaderboard">
          <Trophy size={16} weight="fill" className="text-igc-goldText" />
          {topReps.map((r) => (
            <span key={r.rank} className="text-igc-muted text-xs whitespace-nowrap" data-testid={`motivation-leader-${r.rank}`}>
              <span className="text-igc-goldText font-medium">#{r.rank}</span> {r.name} <span className="text-igc-success">${r.total_commission.toLocaleString()}</span>
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
